<template lang="pug">
	
	.engagement
		engagement-intro.engagement-section
		engagement-slider.engagement-section

		//- background

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'

	import EngagementIntro from './_components/engagement-intro.vue'
	import EngagementSlider from './_components/engagement-slider.vue'
	import Background from '../../components/background.vue'
	import Scrollable from '../../abstracts/scrollable'
	import FlagsOverlay from '../../components/flags-overlay.vue'

  	@Component({
		name: 'Political',
		components: {FlagsOverlay, Background, EngagementIntro,EngagementSlider },
		data: function() {
			return {
				introDistance: 0
			}		
		}
	})

	class Political extends Scrollable {

		mounted () {
			super.mounted()

			this._dom()
		}

		init () {
			super.init()

		}

		_bind () {
			super._bind()
		}

		_dom () {
			this.$flagsOverlay = this.$el.querySelector('.flags-overlay')
		}

		initIntervals () {

		
		}

		_resize () {
			super._resize()

			this.introDistance = this.bounds.height

			this.initIntervals()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default Political

</script>


<style lang="stylus">
	
	@import '../../theme/utils'
	@import '../../theme/variables'
	
	.engagement
		width 100%
		background $COLOR_BLUE
		position relative

		.engagement-section
			position relative
			z-index 30

		.flags-overlay
			position absolute
			top 0
			left 0
			z-index 50

</style>


// WEBPACK FOOTER //
// engagement.vue?4437792d